import { useCallback } from 'react';
import { FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import {
  passwordMinCharacters,
  passwordContainNumber,
  passwordContainUppercase,
  passwordContainLowercase,
} from 'Utils/security';
import { PasswordValidationProps } from './types';

const conditions = [
  {
    label: 'Auth.password.validationCharacters',
    callback: passwordMinCharacters,
  },
  {
    label: 'Auth.password.validationNumber',
    callback: passwordContainNumber,
  },
  {
    label: 'Auth.password.validationCapitalLetter',
    callback: passwordContainUppercase,
  },
  {
    label: 'Auth.password.validationLowerCase',
    callback: passwordContainLowercase,
  },
];

const PasswordValidation = ({ password, isAccount }: PasswordValidationProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.AUTH);
  const isValid = useCallback(callback => callback(password), [password]);
  return (
    <FlexContainer direction="column">
      {conditions.map(item => (
        <FlexContainer align="center" key={item.label}>
          {isValid(item.callback) ? (
            <Icon icon="IconTickSolidSDark" color={isAccount ? 'active' : 'cold'} />
          ) : (
            <Icon icon="IconDangerAttentionSolidS" />
          )}
          <Text type="paragraphs" size="S_M_S" color="dark">
            {t(item.label)}
          </Text>
        </FlexContainer>
      ))}
    </FlexContainer>
  );
};

export default PasswordValidation;
